import { render } from "./Versions.vue?vue&type=template&id=e19c181c"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/planning/Versions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e19c181c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e19c181c', __exports__)) {
    api.reload('e19c181c', __exports__)
  }
  
  module.hot.accept("./Versions.vue?vue&type=template&id=e19c181c", () => {
    api.rerender('e19c181c', render)
  })

}


export default __exports__